<app-dashboard-container
	class="dashboard-uitzondering"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions, $event)"
>
	<app-filter-panel
		[defaultFilters]="initialFilters"
		[allFilters]="allFilters()"
		[overrideDefault]="overrideDefault"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/doorstroom"
		[permanentFilterExpressions]="permanentFilterExpressions"
	></app-filter-panel>
	<app-filter-bar
		[showTerug]="!navigatieVoorkeurService.nieuweNavigatie() && from !== undefined"
		[terugPageNiet]="'/details'"
		[dataRootSelection]="dataRootSelection()"
	></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			@if (aantalJaren) {
				<div class="cl-header-subtitle">
					{{ getSchooljarenCaption() }}
					@if (getSchooljarenTooltip()) {
						<app-icon
							name="info"
							color="primary-1"
							hoverColor="primary-2"
							size="small"
							[appTooltip]="getSchooljarenTooltip()!"
						></app-icon>
					}
				</div>
			}
			@if (aantalJaren) {
				<app-schooljaar-indicator-over [hideExclusief]="hideExclusief"></app-schooljaar-indicator-over>
			}
		</app-dashboard-header>
		<app-barchart-table
			[filters]="filterExpressions()"
			[permanentFilters]="permanentFilterExpressions"
			[groups]="groups"
			[config]="this"
			[barchartWidth]="200"
		></app-barchart-table>
	</section>
</app-dashboard-container>
